import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Billboard from "@views/home/Billboard";
import PersonBoard from "@views/home/PersonBoard";
import LeagueBoard from "@views/home/LeagueBoard";
import Search from "@views/shop/GoodSearch";
import LessonsClass from "@views/shop/LessonsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import UploadImage from "../extra/UploadImage";
import Category from "@views/shop/GoodsClass";
import CategoryEj from "@views/shop/GoodsClassEj";
import ProductDetail from "@views/shop/ProductDetail";
import ECardDetail from "@views/order/ECardDetail";
import GoodsType from "@views/shop/GoodsType";
import ClassTj from "@components/ClassTj";

import $store from "../store";
// import {toLogin} from "@libs/login";
import toLoginLesson, { checkLoginAndLeague } from "@libs/lessonLogin";
import { checkTokenServ } from "@api/user";
import Loading from "@views/Loading";
import request from "@utils/request";
import MatchLoading from "@views/MatchLoading";
import $vm from "../main";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/manager/uploadImage",
      name: "UploadService",
      component: UploadImage,
      meta: {
        title: "团课维护",
        keepAlive: false,
        auth: false
      }
    },
    {
      path: "/",
      name: "home_new",
      meta: {
        title: "首页",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/home_new/index.vue")
    },
    {
      path: "/lessons",
      name: "home_new",
      meta: {
        title: "大学习首页",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: LessonsClass
      // component: () => import("@views/home_new/index.vue")
    },
    {
      path: "/user_ej",
      name: "userEj",
      meta: {
        title: "首页",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/user/UserEj.vue")
    },
    {
      path: "/message",
      name: "msssageEj",
      meta: {
        title: "消息中心",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/user/msssageEj.vue")
    },
    {
      path: "/messageDetail",
      name: "messageEjDetail",
      meta: {
        title: "消息中心",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/user/messageEjDetail.vue")
    },
    {
      path: "/find",
      name: "find",
      meta: {
        title: "发现",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/activity_new/find.vue")
    },
    {
      path: "/participateIn",
      name: "find",
      meta: {
        title: "参与",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/activity_new/me-activity.vue")
    },
    {
      path: "/editActivityList",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/activity_new/edit-activity-list.vue")
    },
    {
      path: "/editActivity",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/activity_new/edit-acyivity.vue")
    },
    {
      path: "/youthRole",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/youth-role-models/index2.vue")
    },
    {
      path: "/youthRoleItems",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/youth-role-models/items.vue")
    },
    {
      path: "/youthRole2",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/youth-role-models/index.vue")
    },
    {
      path: "/youthRoleChildren",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/youth-role-models/children.vue")
    },
    {
      path: "/ldbj",
      name: "find",
      meta: {
        title: "编辑",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/home_new/ldbj.vue")
    },
    {
      path: "/second_level",
      name: "find",
      meta: {
        title: "活动详情",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/activity_new/acyivity_second_level.vue")
    },
    {
      path: "/activity",
      name: "activity",
      meta: {
        title: "发布活动",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/activity_new/index.vue")
    },
    {
      path: "/qingyun",
      name: "qingyun",
      meta: {
        title: "青耘北疆",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      // component: LessonsClass
      component: () => import("@views/qingyun/index.vue")
    },
    // {
    //   path: "/message",
    //   name: "message",
    //   meta: {
    //     title: "消息",
    //     keepAlive: false,
    //     footer: true,
    //     backgroundColor: "#fff",
    //     auth: true
    //   },
    //   // component: LessonsClass
    //   component: () => import("@views/message/index.vue")
    // },
    {
      path: "/home_new",
      name: "PersonResult",
      meta: {
        title: "主页",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () => import("@views/home_new/index.vue")
    },
    {
      path: "/on_the_go",
      name: "onTheGo",
      meta: {
        title: "随手拍主题列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/onTheGo.vue")
    },
    {
      path: "/duanshipin",
      name: "Duanshipin",
      meta: {
        title: "随手拍主题列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/duanshipin.vue")
    },
    {
      path: "/duanshipin_show",
      name: "DuanshipinShow",
      meta: {
        title: "随手拍主题列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/duanshipin_show.vue")
    },
    {
      path: "/test",
      name: "onTheGo",
      meta: {
        title: "随手拍主题列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/activity_new/test1.vue")
    },
    {
      path: "/test2",
      name: "onTheGo",
      meta: {
        title: "随手拍主题列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/activity_new/test2.vue")
    },
    {
      path: "/on_the_go_me_list",
      name: "onTheGoList",
      meta: {
        title: "随手拍图片列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/onTheGoMeList.vue")
    },
    {
      path: "/test_ui",
      name: "testUi",
      meta: {
        title: "ces",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/test-ui.vue")
    },
    {
      path: "/on_the_go_list",
      name: "onTheGoList",
      meta: {
        title: "随手拍图片列表",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/onTheGoList.vue")
    },
    {
      path: "/on_the_go_send",
      name: "onTheGoSend",
      meta: {
        title: "随手拍",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/home_new/onTheGoSend.vue")
    },
    {
      path: "/news_media",
      name: "onTheGoSend",
      meta: {
        title: "新媒体矩阵",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/newmediamatrix/index4.vue")
    },
    {
      path: "/qingTingBeiJiang",
      name: "qingTingBeiJiang",
      meta: {
        title: "新媒体矩阵",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/qingTingBeiJiang/index.vue")
    },
    {
      path: "/qingTingBeiJiangInput",
      name: "qingTingBeiJiang",
      meta: {
        title: "新媒体矩阵",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/qingTingBeiJiang/input.vue")
    },
    {
      path: "/qingchunxiaoyuan",
      name: "qingchunxiaoyuan",
      meta: {
        title: "青春校园",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/qingchunxiaoyuan/index.vue")
    },
    {
      path: "/customer/chat/:id/:productId?",
      name: "CustomerService",
      meta: {
        title: "客服聊天",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/user/CustomerService.vue")
    },
    {
      path: "/match",
      name: "MatchIndex",
      meta: {
        title: "知识竞赛",
        keepAlive: false,
        auth: false
      },
      component: () => import("@views/match/MatchIndex.vue")
    },
    {
      path: "/oldClass",
      name: "OldClassList",
      meta: {
        title: "懒加载",
        keepAlive: false,
        auth: false
      },
      component: () => import("@components/OldClassList.vue")
    },
    {
      path: "/personResult",
      name: "PersonResult",
      meta: {
        title: "我的战绩",
        keepAlive: false,
        auth: false
      },
      component: () => import("@views/match/PersonResult.vue")
    },
    {
      path: "/matchRank",
      name: "MatchRank",
      meta: {
        title: "答题排行榜",
        keepAlive: false,
        auth: false
      },
      component: () => import("@views/match/MatchRank.vue")
    },
    {
      path: "/Billboard",
      name: "Billboard",
      meta: {
        title: "xue",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: false
      },
      component: Billboard
    },
    {
      path: "/PersonBoard",
      name: "PersonBoard",
      meta: {
        title: "xue",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: PersonBoard
    },
    {
      path: "/LeagueBoard",
      name: "LeagueBoard",
      meta: {
        title: "xue",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: LeagueBoard
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: Category
    },
    {
      path: "/categoryEj/:pid?",
      name: "GoodsClassEj",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: CategoryEj
    },
    {
      path: "/classTj",
      name: "ClassTj",
      meta: {
        title: "本期学习确认页",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: ClassTj
    },
    {
      path: "/productDetail",
      name: "ProductDetail",
      meta: {
        title: "商品明细",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: ProductDetail
    },
    {
      path: "/eCardDetail",
      name: "ECardDetail",
      meta: {
        title: "我的券码",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: ECardDetail
    },
    {
      path: "/goodsType",
      name: "GoodsType",
      meta: {
        title: "商品列表",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: GoodsType,
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsCollection.vue")
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: Search
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/EvaluateList.vue")
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/GoodsEvaluate.vue")
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false
      },
      component: () => import("@views/shop/GoodsPromotion.vue")
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false
      },
      component: () => import("@views/shop/HotNewGoods.vue")
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "商品详情",
        keepAlive: false
      },
      component: () => import("@views/shop/GoodsCon.vue")
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false
      },
      component: () => import("@views/shop/StoreList.vue")
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true
      },
      component: ShoppingCart
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true
      },
      component: GoodsList
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "注册",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Register.vue")
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue")
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "找回密码",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue")
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: false
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    {
      path: "/test",
      name: "Test",
      meta: {
        title: "登录",
        keepAlive: false,
        auth: false
      },
      component: () => import(/* webpackChunkName: "login" */ "@views/Test.vue")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: false
      },
      component: Loading
    },
    {
      path: "/match/auth/:url",
      name: "MatchLoading",
      meta: {
        title: " 加载中",
        keepAlive: false
      },
      component: MatchLoading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return {
      x: 0,
      y: to.meta.scrollTop || 0
    };
  }
});

const { back, replace } = router;
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { backgroundColor, footer, home, auth } = to.meta;
  if ($store.state.userIp === null || $store.state.userIp === undefined) {
    $store.dispatch("USERIP");
  }
  if (to.path === "/login") {
    return toLoginLesson(true, "/");
  }
  if (to.path === "/") {
    checkLoginAndLeague(to);
  }
  if (to.path === "/user") {
    checkLoginAndLeague(to);
  }
  if (to.path === "/userEj") {
    checkLoginAndLeague(to);
  }
  if (to.path === "/Billboard") {
    checkLoginAndLeague(to);
  }
  if (to.path === "/category") {
    console.log(to.path)
    checkLoginAndLeague(to);
  }
  if (auth === true) {
    if (form.name === "Login") return;
    checkTokenServ().then(res => {
      console.log("checkToken");
      console.log(res);
      let resultKey = res.resultKey;
      if (
        typeof resultKey === "undefined" ||
        resultKey === undefined ||
        resultKey === "" ||
        resultKey == null
      ) {
        console.log("调用失败，走跳转重新调用");
        let resOld = res.toString();
        console.log(resOld);
        let code = resOld
          .split("http://qndxx.nmyouth.org.cn/service/user/checkTokenServ?")[1]
          .split('"')[0];
        console.log(code);
        let redirectPath = "/user/checkTokenServ?" + code;
        console.log(redirectPath);
        request.get(redirectPath).then(res2 => {
          console.log(":::::::::::res2=");
          console.log(res2);
          request.get("/user/checkTokenServ").then(res3 => {
            console.log(":::::::::::res3=");
            console.log(res3);
            let resultKey = res3.resultKey;
            if (resultKey === "1") {
              return toLoginLesson(true, to.fullPath);
            }
          });
        });
      } else {
        if (resultKey === "1") {
          return toLoginLesson(true, to.fullPath);
        }
      }
    });
  }
  document.title = "蒙青E家";
  if (
    to.path === "/match" ||
    to.path === "/personResult" ||
    to.path === "/matchRank"
  ) {
    document.title = "蒙青E家";
  }
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示BindingLeague.vue
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");
  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;
